import React from 'react';
import PropTypes from 'prop-types';
import SlideshowButtonNode from './slideshow-button-node';
import SlideNode from './slide-node';
import {withRouter} from 'react-router-dom';


const getDataFromNode = function(node) {
    return ['id', 'title', 'required', 'enabled', 'visible'].reduce((data, key) => {
        return {...data, [key]: node.attr[key]};
    }, {});
};

const getStateFromProps = function(props = {}) {
    const nextButtonNode = props.node.childNamed('next_button_node') || null;
    const prevButtonNode = props.node.childNamed('prev_button_node') || null;
    const slideNodes = props.node.childrenNamed('slide_node') || null;
    const slideshowLength = slideNodes.length;
    return {
        ...getDataFromNode(props.node),
        nextButtonNode,
        prevButtonNode,
        slideNodes,
        slideshowLength,
    };
};

class SlideshowNode extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getStateFromProps(props),
            currentSlideIndex: 0, // the slide in slideNodes that should show
            height: 0,
            hovered: false,
            required: props.required,
            enabled: props.enabled,
            zIndex: props.zIndex
        };
        this.state.disablePrevButton = true;
        this.state.disableNextButton = (this.state.slideshowLength === 0);

        this.nextSlide = this.nextSlide.bind(this);
        this.prevSlide = this.prevSlide.bind(this);
    }

    //proceed to the next slide in a slideshow
    nextSlide() {
        const {currentSlideIndex, slideshowLength} = this.state;
        const newSlideIndex= currentSlideIndex + 1;

        this.setState({
            currentSlideIndex: newSlideIndex,
            disablePrevButton: newSlideIndex === 0,
            disableNextButton: newSlideIndex >= slideshowLength - 1,
        });
    }

    //return to the previous slide in a slideshow
    prevSlide() {
        const {currentSlideIndex, slideshowLength} = this.state;
        const newSlideIndex= currentSlideIndex - 1;

        this.setState({
            currentSlideIndex: newSlideIndex,
            disablePrevButton: newSlideIndex === 0,
            disableNextButton: newSlideIndex >= slideshowLength - 1,
        });
    }

    componentDidMount() {
        document.addEventListener('next-slide', this.nextSlide);
        document.addEventListener('prev-slide', this.prevSlide);

    }

    componentWillUnmount() {
        document.removeEventListener('next-slide', this.nextSlide);
        document.removeEventListener('prev-slide', this.prevSlide);

    }

    render() {
        const {moduleURL = '', enableJREAppPlayerContainerButtons, disableJREAppPlayerContainerButtons,} = this.props;
        const { nextButtonNode, prevButtonNode, slideNodes, currentSlideIndex, disablePrevButton, disableNextButton } = this.state;
        return (
            <div className="slideshow-node">
                {slideNodes &&
                <div>
                    <SlideNode
                        node={slideNodes[currentSlideIndex]}
                        moduleURL={moduleURL}
                        enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                        disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />
                    {/*next button*/}
                    <SlideshowButtonNode
                        node={nextButtonNode}
                        action="next"
                        disableButton={disableNextButton}
                        moduleURL={moduleURL}
                    />
                    {/*previous button*/}
                    <SlideshowButtonNode
                        node={prevButtonNode}
                        action="prev"
                        disableButton={disablePrevButton}
                        moduleURL={moduleURL}
                    />
                </div>
                }
            </div>
        );
    }
}

SlideshowNode.propTypes = {
    node: PropTypes.object.isRequired,
    moduleURL: PropTypes.string.isRequired,
};

export default withRouter(SlideshowNode);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/slideshow-node.js